import { ComponentProps, useState } from "react";
import timezones from "timezones-list";

import { FieldGroup } from "@design-system/FieldGroup/FieldGroup";
import { Select } from "@design-system/Select/Select";

import { STORAGE_KEYS } from "@utils/storageKeys";

const DEFAULT_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

const TIMEZONE_OPTIONS = Intl.supportedValuesOf("timeZone").map(
  (supportedTimeZone) => ({
    id: supportedTimeZone,
    label:
      timezones.find((timezone) => timezone.tzCode === supportedTimeZone)
        ?.label || supportedTimeZone,
  }),
);

export const TimezoneSelect = () => {
  const [timezone, setTimezone] = useState<string>(
    localStorage.getItem(STORAGE_KEYS.TIMEZONE) ?? DEFAULT_TIMEZONE,
  );

  const handleChange: ComponentProps<typeof Select>["onChange"] = (value) => {
    setTimezone((value as string) || DEFAULT_TIMEZONE);
    localStorage.setItem(
      STORAGE_KEYS.TIMEZONE,
      (value as string) || DEFAULT_TIMEZONE,
    );
  };

  return (
    <FieldGroup label="Timezone">
      <Select
        options={TIMEZONE_OPTIONS}
        onChange={handleChange}
        value={timezone}
      />
    </FieldGroup>
  );
};
